import { ApiClient } from '@inspace-org/client';
import { apiCredentials } from './credentials';
import env from '../../env';
import { language } from '../../localization';

export const apiUrl = env.apiUrl;
export const api = new ApiClient({ baseUrl: apiUrl, credentials: apiCredentials, prefix: '/api', language });
